import { useState, useEffect } from "react"
import { api } from "aldoo-ra/API"
import { url } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { useHelpCenterHomeSeed } from "../ssr-seed"

const hcAPI = api("help-center")

// The section's cards: its published categories, then its published articles
const popularItems = (content) => [
  ...(content?.categories || []).filter((c) => c.status === "published").map((c) => ({ ...c, _type: "category" })),
  ...(content?.articles || []).filter((a) => a.status === "published").map((a) => ({ ...a, _type: "article" })),
]

const PopularCategories = () => {
  const texts = TextBundle({ id: "help-center" })
  const [currentLanguage] = useState(() => {
    try {
      const stored = localStorage.getItem("current-site-language")
      return stored ? stored.replace(/"/g, "") : "en"
    } catch { return "en" }
  })

  // rendered by the server: start from its copy and skip the fetch
  const seed = useHelpCenterHomeSeed(currentLanguage)
  const [items, setItems] = useState(() => (seed ? popularItems(seed.popular?.content) : []))
  const [isLoading, setIsLoading] = useState(!seed)
  const [sectionName, setSectionName] = useState(seed?.popular?.content?.name || "Most Popular")

  useEffect(() => {
    if (seed) return
    const fetchItems = async () => {
      try {
        const response = await hcAPI({
          get_content: { contentURL: "/category/most-popular", language: currentLanguage },
        })

        const content = response?.content
        if (!content) { setItems([]); return }

        setSectionName(content.name || "Most Popular")
        setItems(popularItems(content))
      } catch {
        setItems([])
      } finally {
        setIsLoading(false)
      }
    }
    fetchItems()
  }, [currentLanguage])

  const handleCategoryClick = (slug) => {
    window.location.href = `/help-center/category/${slug}`
  }

  const handleArticleClick = (slug) => {
    if (window.loadHelpCenterContent) {
      window.loadHelpCenterContent("article", slug, null)
    } else {
      window.location.href = `/help-center/article/${slug}`
    }
  }

  if (isLoading) return (
    <div className="py-8 text-center">
      <Typography variant="txt1_dim">
        {texts?.loading_popular_cat}
      </Typography>
    </div>
  )

  if (!items.length) return null

  return (
    <div>
      <Typography 
        variant="h2" 
        className="text-center md:text-left mb-6 md:mb-11"
      >
        {sectionName}
      </Typography>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-7">
        {items.map((item) => item._type === "category" ? (
          <a
            key={item._id}
            href={`/help-center/category/${item.slug}`}
            className="h-[186px] flex flex-col items-center justify-center paper_20 hover:bg-paper border-4 border-theme_white hover:grad_border_4 rounded-[30px] p-8 cursor-pointer hover:shadow-md transition-all no-underline"
            onClick={(e) => { e.preventDefault(); handleCategoryClick(item.slug) }}
          >
            {item.icon && (
              <div className="h-[60px] w-[60px] mb-4">
                <img src={url(item.icon)} alt={`${item.label} icon`} className="h-full w-auto object-contain" />
              </div>
            )}
            <Typography variant="h4" className="text-left my-0">
              {item.label}
            </Typography>
          </a>
        ) : (
          <a
            key={item._id}
            href={`/help-center/article/${item.slug}`}
            className="h-[186px] flex flex-col items-center justify-center paper_20 hover:bg-paper border-4 border-theme_white hover:grad_border_4 rounded-[30px] p-8 cursor-pointer shadow-sm hover:shadow-md transition-all no-underline"
            onClick={(e) => { e.preventDefault(); handleArticleClick(item.slug) }}
          >
            <Typography variant="h4" className="text-center my-0">
              {item.label}
            </Typography>
          </a>
        ))}
      </div>
    </div>
  )
}

export default PopularCategories
